import LessonCard from "../components/LessonCard/LessonCard"

const Lesson = () => {
  return (
    <main>
        <h1>Lesson Reminder</h1>
        <div className="container">
            <LessonCard />
        </div>
    </main>
  )
}

export default Lesson